import React from 'react';
import PropTypes from 'prop-types';

const CalciteCheckbox = ({checked, scale, status, onChange, testId, className}) => {
  const calciteCheckboxRef = React.useRef(null);
  React.useEffect(() => {
    const element = calciteCheckboxRef.current;
    if (onChange && element) {
      element.addEventListener('calciteCheckboxChange', onChange);
    }
    return () => {
      if (onChange && element) {
        element.removeEventListener('calciteCheckboxChange', onChange);
      }
    };
  }, []);
  return (
    <calcite-checkbox
      data-testid={testId}
      class={className}
      checked={checked || undefined}
      scale={scale || undefined}
      status={status || undefined}
      onChange={onChange || undefined}
      ref={calciteCheckboxRef}
    ></calcite-checkbox>
  );
};

CalciteCheckbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  scale: PropTypes.string,
  status: PropTypes.string,
  onChange: PropTypes.func,
  testId: PropTypes.string,
};

export default CalciteCheckbox;
